// Simple wrapper for a web worker to add support for Promises
// Based on https://github.com/nolanlawson/promise-worker

let messageId = 0

class PromiseWorker {
  constructor(worker) {
    this._worker = worker
    this._callbacks = {}
    this._handleMessage = this._handleMessage.bind(this)
    this._worker.addEventListener('message', this._handleMessage)
  }

  postMessage(userMessage) {
    messageId += 1
    const messageToSend = JSON.stringify([messageId, userMessage])

    return new Promise((resolve, reject) => {
      this._callbacks[messageId] = (error, result) => {
        if (error) {
          return reject(new Error(error.message))
        }
        resolve(result)
      }
      this._worker.postMessage(messageToSend)
    })
  }

  destroy() {
    this._worker.removeEventListener('message', this._handleMessage)
    this._worker = null
    this._callbacks = {}
  }

  _handleMessage(e) {
    const message = JSON.parse(e.data)

    if (!message) {
      return
    }
    const [messageId, error, result] = message
    const callback = this._callbacks[messageId]

    if (!callback) {
      return
    }

    delete this._callbacks[messageId]
    callback(error, result)
  }
}

export default PromiseWorker
